import { Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import BackButton from "../../components/backButton/BackButton";
import NewSARForm from "./NewSARForm";

export function NewSAR() {
    const { t } = useTranslation();
    
    return (
        <Container className="py-3">
            <Row className="justify-content-center">
                <Col>
                    <Card className="shadow">
                        <Card.Body>
                            <Card.Title className="d-flex align-items-center mb-3">
                                <BackButton path="/sars" />
                                <span>{t("dsar.form.title")}</span>
                            </Card.Title>
                            <Card.Text as="div">
                                <NewSARForm />
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}